import { useEffect, useRef, useState } from "react";
import { accountingCRUD } from "../../../actions/accounting";
import { Button, DateRangePicker, SelectPicker } from "rsuite";
import { char } from "../../../utils";
import { invoiceCRUD } from "../../../actions/invoice";
import { reportCRUD } from "../../../actions/report";
import { SuzaIncome } from "./data/suza";
import { AccountIncome, CollectionCenterIncome } from "./data";
import { DownloadTableExcel } from "react-export-table-to-excel";
import FilePdfOIcon from "@rsuite/icons/legacy/FilePdfO";
import FileExcelOIcon from "@rsuite/icons/legacy/FileExcelO";
import { useReactToPrint } from "react-to-print";
import moment from "moment";

const { afterToday } = DateRangePicker;

export const IncomeReportContent = () => {
  const dataRef = useRef();
  const tableRef = useRef();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [center, setCenter] = useState([]);
  const [centerId, setCenterId] = useState(null);
  const [loadAccount, setLoadAccount] = useState(false);
  const [account, setAccount] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [date, setDate] = useState([]);
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(1);
  const [nextPage, setNextPage] = useState(1);

  useEffect(() => {
    setTimeout(() => {
      accountingCRUD.loadCollectionCenter("", "", "", "name").then((resp) => {
        setCenter(resp.data);
      });
    }, 500);
  }, []);

  const handleGeneratePdf = useReactToPrint({
    content: () => dataRef.current,
  });

  useEffect(() => {
    if (centerId) {
      setLoadAccount(true);
      setTimeout(() => {
        invoiceCRUD
          .loadInstitutionAccount("", "", centerId, "", "", "id")
          .then((resp) => {
            setAccount(resp.data);
          })
          .catch(() => {})
          .finally(() => {
            setLoadAccount(false);
          });
      }, 500);
    }
  }, [centerId]);

  useEffect(() => {
    setLoading(true);
    setData([]);
    setTimeout(() => {
      if (date.length > 0) {
        if (accountId) {
          console.log(date);
          reportCRUD
            .loadAccountIncomeReportDate(
              accountId,
              limit,
              nextPage,
              date[0],
              date[1],
            )
            .then((resp) => {
              setData(resp.data);
            })
            .catch(() => {})
            .finally(() => {
              setLoading(false);
            });
        } else if (centerId) {
          reportCRUD
            .loadCenterIncomeReportDate(centerId, date[0], date[1])
            .then((resp) => {
              setData(resp.data);
            })
            .catch(() => {})
            .finally(() => {
              setLoading(false);
            });
        } else {
          reportCRUD
            .loadSuzaIncomeReportDate(date[0], date[1])
            .then((resp) => {
              setData(resp.data);
            })
            .catch(() => {})
            .finally(() => {
              setLoading(false);
            });
        }
      } else if (accountId) {
        reportCRUD
          .loadAccountIncomeReport(accountId, limit, nextPage)
          .then((resp) => {
            setData(resp.data);
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
          });
      } else if (centerId) {
        reportCRUD
          .loadCenterIncomeReport(centerId)
          .then((resp) => {
            setData(resp.data);
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
          });
      } else {
        reportCRUD
          .loadSuzaIncomeReport()
          .then((resp) => {
            setData(resp.data);
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
          });
      }
    }, 500);
  }, [centerId, accountId, date, limit, nextPage, page]);

  const handleChangePage = (event) => {
    setData([]);

    setPage(event);
    setNextPage(event);
  };

  const handleChange = (selectedOption) => {
    setData([]);
    setLimit(selectedOption);
    setNextPage(1);
    setPage(1);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2" style={{ marginTop: -30 }}>
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">SUZA Income Report</p>
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row">
          <div className="col-12 card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3 col-sm-12">
                  <SelectPicker
                    className="w-100"
                    cleanable={true}
                    data={center?.map((dt) => ({
                      value: dt.id,
                      label: char.toTitleCase(dt.name),
                    }))}
                    onChange={(e) => {
                      setCenterId(e);
                      setAccountId(null);
                    }}
                    placeholder="Select Collection Center"
                    onClean={() => {
                      setCenterId(null);
                      setAccountId(null);
                    }}
                  />
                </div>
                <div className="col-md-3 col-sm-12">
                  <SelectPicker
                    className="w-100"
                    cleanable={true}
                    data={account?.map((dt) => ({
                      value: dt.id,
                      label: char.processParagraph(dt.name),
                    }))}
                    onChange={(e) => setAccountId(e)}
                    placeholder="Select Collection Item"
                    onClean={() => {
                      setAccountId(null);
                    }}
                    loading={loadAccount}
                  />
                </div>
                <div className="col-md-2 col-sm-12">
                  <DateRangePicker
                    cleanable
                    placement="bottomEnd"
                    onClean={() => setDate([])}
                    onShortcutClick={(e) => {
                      setDate([
                        moment(e.value[0]).format("YYYY-MM-DD"),
                        moment(e.value[1]).add(1, "days").format("YYYY-MM-DD"),
                      ]);
                    }}
                    onOk={(e) =>
                      setDate([
                        moment(e[0]).format("YYYY-MM-DD"),
                        moment(e[1]).add(1, "days").format("YYYY-MM-DD"),
                      ])
                    }
                    shouldDisableDate={afterToday()}
                    placeholder="Select date range"
                    className="w-100"
                  />
                </div>
                {data ? (
                  <>
                    <div className="col-md-2 col-sm-6">
                      <Button
                        color="green"
                        appearance="primary"
                        startIcon={<FileExcelOIcon />}
                        block={true}
                        disabled={!data}
                      >
                        <DownloadTableExcel
                          filename="Report"
                          sheet="sheet1"
                          currentTableRef={tableRef.current}
                        >
                          Download Excel
                        </DownloadTableExcel>
                      </Button>
                    </div>
                    <div className="col-md-2 col-sm-6">
                      <Button
                        color="red"
                        appearance="primary"
                        startIcon={<FilePdfOIcon />}
                        block={true}
                        onClick={handleGeneratePdf}
                        disabled={!data}
                      >
                        Download PDF
                      </Button>
                    </div>
                  </>
                ) : null}
              </div>
              <hr />
              {accountId ? (
                <AccountIncome
                  data={data}
                  loading={loading}
                  limit={limit}
                  page={page}
                  handleChangePage={handleChangePage}
                  handleChange={handleChange}
                  dataRef={dataRef}
                  tableRef={tableRef}
                />
              ) : centerId ? (
                <CollectionCenterIncome
                  data={data}
                  loading={loading}
                  dataRef={dataRef}
                  tableRef={tableRef}
                />
              ) : (
                <SuzaIncome
                  data={data}
                  loading={loading}
                  dataRef={dataRef}
                  tableRef={tableRef}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
